import VDivider from './VDivider'

export { VDivider }
export default VDivider



// WEBPACK FOOTER //
// ../../../src/components/VDivider/index.ts